import _regeneratorRuntime from "/home/chdeploy/jenkins/jenkins/workspace/ch_deploy_webpc_test-jh_clife/node_modules/@babel/runtime-corejs2/helpers/esm/regeneratorRuntime.js";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/home/chdeploy/jenkins/jenkins/workspace/ch_deploy_webpc_test-jh_clife/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/home/chdeploy/jenkins/jenkins/workspace/ch_deploy_webpc_test-jh_clife/node_modules/@babel/runtime-corejs2/helpers/esm/classCallCheck.js";
import _createClass from "/home/chdeploy/jenkins/jenkins/workspace/ch_deploy_webpc_test-jh_clife/node_modules/@babel/runtime-corejs2/helpers/esm/createClass.js";
import _inherits from "/home/chdeploy/jenkins/jenkins/workspace/ch_deploy_webpc_test-jh_clife/node_modules/@babel/runtime-corejs2/helpers/esm/inherits.js";
import _createSuper from "/home/chdeploy/jenkins/jenkins/workspace/ch_deploy_webpc_test-jh_clife/node_modules/@babel/runtime-corejs2/helpers/esm/createSuper.js";
/**
 * 长鸿字典
 * */
import AvueSelectTemplateService from "../AvueSelectTemplateService";
var ChAvueSelectTemplateImpl = /*#__PURE__*/function (_AvueSelectTemplateSe) {
  _inherits(ChAvueSelectTemplateImpl, _AvueSelectTemplateSe);
  var _super = _createSuper(ChAvueSelectTemplateImpl);
  function ChAvueSelectTemplateImpl() {
    _classCallCheck(this, ChAvueSelectTemplateImpl);
    return _super.apply(this, arguments);
  }
  _createClass(ChAvueSelectTemplateImpl, [{
    key: "abstractQueryDictData",
    value: function () {
      var _abstractQueryDictData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(dictType) {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", [{
                  label: '选项1',
                  value: 0
                }, {
                  label: '选项2',
                  value: 1
                }]);
              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      function abstractQueryDictData(_x) {
        return _abstractQueryDictData.apply(this, arguments);
      }
      return abstractQueryDictData;
    }()
  }]);
  return ChAvueSelectTemplateImpl;
}(AvueSelectTemplateService);
export { ChAvueSelectTemplateImpl as default };